import {
  AddItemToBasketRequest,
  addItemToBasketRequestOutputTransformer,
} from '../interfaces/Basket/AddItemToBasketRequest';
import api, { apiPrefix } from './Api';
import {
  BasketSummary,
  basketSummaryFromResponse,
} from '../interfaces/Basket/BasketSummary';
import {
  ValidatedBasket,
  validatedBasketFromResponse,
} from '../interfaces/Basket/ValidatedBasket';

const basketApiPrefix = `${apiPrefix}/basket`;
const basketPublicApiPrefix = `${apiPrefix}/basket-public`;

export const addItemToBasketAuth = async (
  req: AddItemToBasketRequest,
): Promise<void> =>
  api.post(basketApiPrefix, addItemToBasketRequestOutputTransformer(req));

export const getBasketSummaryAuth = async (): Promise<BasketSummary> => {
  const response = await api.get(basketApiPrefix);

  return basketSummaryFromResponse(response.data);
};

export const getDynamicBasket = async (
  items: AddItemToBasketRequest[],
): Promise<BasketSummary> => {
  const response = await api.post(
    basketPublicApiPrefix,
    items.map(addItemToBasketRequestOutputTransformer),
  );

  return basketSummaryFromResponse(response.data);
};

export const getValidatedBasket = async (
  items: AddItemToBasketRequest[],
): Promise<ValidatedBasket[]> => {
  const response = await api.post(
    `${basketPublicApiPrefix}/validate`,
    items.map(addItemToBasketRequestOutputTransformer),
  );

  return response.data?.data?.map(validatedBasketFromResponse) ?? [];
};

export const updateBasketItemQuantityAuth = async (
  basketID: number,
  quantity: number,
): Promise<void> => api.put(`${basketApiPrefix}/${basketID}`, { quantity });
